import { render } from "./NewChatForm.vue?vue&type=template&id=30817b9a&scoped=true"
import script from "./NewChatForm.vue?vue&type=script&lang=js"
export * from "./NewChatForm.vue?vue&type=script&lang=js"

import "./NewChatForm.vue?vue&type=style&index=0&id=30817b9a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-30817b9a"]])

export default __exports__